// ★cmd-po_1139: 汎用ボタン共通部品
// catalog po-btn / po-btn-primary / po-btn-secondary の機械転写
// CAC L420-466 sx 転写 + isSmartPhone 高さ分岐（catalog @media 639 L463）
import { Button, type ButtonProps } from "@mui/material";
import { useAtomValue } from "jotai";
import { AppAtoms } from "../../lib/store";

interface PoButtonOwnProps {
  /** primary = filled ai-blue, secondary = outlined. デフォルト primary */
  variant?: "primary" | "secondary";
}

export type PoButtonProps = PoButtonOwnProps & Omit<ButtonProps, "variant">;

export function PoButton({
  variant = "primary",
  sx,
  className,
  ...rest
}: PoButtonProps) {
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  // catalog @media (max-width: 639px) L463: SP 44px / PC 36px
  // ★alert_20260817_sp_breakpoint_unify: app isSmartPhone<400 と catalog 639 の既知乖離（1138 と同扱い）
  const height = isSmartPhone
    ? "var(--control-h-sp, 44px)"
    : "var(--control-h, 36px)";

  if (variant === "secondary") {
    return (
      <Button
        className={`po-btn po-btn-secondary${className ? ` ${className}` : ""}`}
        sx={{
          textTransform: "none",
          minWidth: "unset",
          boxShadow: "none",
          backgroundColor: "var(--color-white, #ffffff)",
          color: "var(--color-ai, #1e3a5f)",
          border: "1px solid var(--color-border, #e5e5e0)",
          padding: "0 var(--sp-4, 16px)",
          gap: "var(--sp-2, 8px)",
          height,
          borderRadius: "var(--radius-sm, 6px)",
          fontSize: "var(--fs-13, 13px)",
          fontWeight: "var(--fw-semibold, 600)",
          "&:hover": {
            boxShadow: "none",
            backgroundColor: "var(--state-hover, rgba(0,0,0,.04))",
          },
          "&.Mui-disabled": {
            bgcolor: "var(--state-disabled-bg, #f0f0ec)",
            color: "var(--state-disabled-fg, #9ca3af)",
            cursor: "not-allowed",
            pointerEvents: "auto",
          },
          ...sx,
        }}
        {...rest}
      />
    );
  }

  // variant === "primary"
  return (
    <Button
      className={`po-btn po-btn-primary${className ? ` ${className}` : ""}`}
      sx={{
        textTransform: "none",
        minWidth: "unset",
        boxShadow: "none",
        backgroundColor: "var(--color-ai, #1e3a5f)",
        color: "var(--color-white, #ffffff)",
        border: "1px solid transparent",
        padding: "0 var(--sp-4, 16px)",
        gap: "var(--sp-2, 8px)",
        height,
        borderRadius: "var(--radius-sm, 6px)",
        fontSize: "var(--fs-13, 13px)",
        fontWeight: "var(--fw-semibold, 600)",
        "&:hover": {
          boxShadow: "none",
          backgroundColor: "var(--color-ai-light, #2a5a8f)",
        },
        "&.Mui-disabled": {
          bgcolor: "var(--state-disabled-bg, #f0f0ec)",
          color: "var(--state-disabled-fg, #9ca3af)",
          cursor: "not-allowed",
          pointerEvents: "auto",
        },
        ...sx,
      }}
      {...rest}
    />
  );
}
